/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TreatmentPlanPermissions { 
    add: boolean;
    change: boolean;
}
export const TreatmentPlanPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TreatmentPlanPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];


